import { motion } from "framer-motion";

const OptionButtons = ({ handleOptionSelect, currentOption }) => {
  // Only render options if no current option is selected
  if (currentOption) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-3">
      <motion.button
        className="border border-gray-400 bg-[#f0f8ff] text-black font-body py-2 px-4 rounded-full"
        onClick={() => handleOptionSelect("Services")}
        whileHover={{ scale: 1.05 }}
      >
        Services
      </motion.button>
      <motion.button
        className="border border-gray-400 bg-[#f0f8ff] text-black font-body py-2 px-4 rounded-full"
        onClick={() => handleOptionSelect("Partnership Assistance")}
        whileHover={{ scale: 1.05 }}
      >
        Partnership Assistance
      </motion.button>
      <motion.button
        className="border border-gray-400 bg-[#f0f8ff] text-black font-body py-2 px-4 rounded-full"
        onClick={() => handleOptionSelect("Helpdesk")}
        whileHover={{ scale: 1.05 }}
      >
        Helpdesk
      </motion.button>
    </div>
  );
};

export default OptionButtons;
